import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {

    componentDidMount() {
        this.reposition();
    }

    componentDidUpdate() {
        this.reposition();
    }

    reposition() {
        const modalInner = document.querySelector('login-modal .modal-inner');
        const top = window.pageYOffset + (window.innerHeight / 2) - (modalInner.offsetHeight / 2);
        modalInner.style.top = top + 'px';
    }

    render({ passwordError, emailError, buttonText, isOpen }) {
        const className = isOpen ? 'open' : null;
        const emailErrorClassName = emailError ? 'error' : null;
        const passwordErrorClassName = passwordError ? 'error' : null;

        return (
            <login-modal class={className}>
                <a class='backdrop' href='#' onClick={this.close} />
                <aside class='modal-inner'>
                    { this.renderHeader() }
                    { this.renderError() }
                    <form onSubmit={this.submit} onKeyUp={this.keyup}>
                        <label class={emailErrorClassName}>
                            Your Email
                            <input
                              data-action='Type-Email'
                              data-category='Three-Card-Reading'
                              data-label='Login'
                              data-ga-event
                              name='email'
                              type='email'
                            />
                        </label>
                        <label class={passwordErrorClassName}>
                            Password
                            <input
                              data-action='Type-Password'
                              data-category='Three-Card-Reading'
                              data-label='Login'
                              data-ga-event
                              maxLength='15'
                              name='password'
                              type='password'
                            />
                        </label>
                        <div class='modal-button-bar'>
                            <a class='forgot-password' target='_blank' href='/password-reset'>Forgot your password?</a>
                            <button class='button button-warning'>{ buttonText }</button>
                        </div>
                    </form>
                </aside>
            </login-modal>
        );
    }

    close = (e) => {
        e.preventDefault();
        this.props.routeTo('');
    }

    submit = (e) => {
        e.preventDefault();
        const form = e.target;
        const email = form.querySelector('input[type="email"]').value;
        const password = form.querySelector('input[type="password"]').value;
        const validEmail = this.isValidEmail(email);
        const validPassword = password.length > 3;

        if (validEmail && validPassword) {
            this.props.userUpdate({ emailError: null, passwordError: null });
            this.props.userLogin({ email: email, password: password });
        } else {
            if (validEmail) {
                this.props.userUpdate({ emailError: null });
            } else {
                this.props.userUpdate({ emailError: 'Please enter a valid email.'});
            }

            if (validPassword) {
                this.props.userUpdate({ passwordError: null });
            } else {
                this.props.userUpdate({ passwordError: 'Please enter a password longer than 3 characters.'});
            }
        }
    }

    keyup = (e) => {
        if (e.keyCode == 27 && this.props.isOpen) {
            this.props.routeTo('');
        }
    }

    renderHeader = () => {
        if (this.props.product) {
            return (
                <header>
                    <h1>{ this.props.h1Text }</h1>
                    <h2>Log in or sign up below for your { this.props.product.type }! It's easy!</h2>
                </header>
            );
        }

        return (
            <header>
                <h1>Welcome Back!</h1>
                <h2>Sign in to Tarot.com</h2>
            </header>
        );
    }

    renderError = () => {
        const error = this.props.emailError ? this.props.emailError : this.props.passwordError;

        if (error) {
            return (
                <div class='error'>{ error }</div>
            );
        }

        return null;
    }

    isValidEmail = (email) => {
        const atpos = email.indexOf('@');
        const dotpos = email.lastIndexOf('.');
        return !(atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length);
    }
}

const mapStateToProps = (state) => ({
    passwordError: state.user && typeof state.user.passwordError === 'boolean'
        ? 'Password did not match this email'
        : state.user.passwordError,
    emailError: state.user && state.user.emailError,
    product: state.product,
    buttonText: state.product ? `Get my ${state.product.type}!` : 'Log In!',
    h1Text: state.product.type && state.product.type.match(/s$/)
        ? `Your ${state.product.type} Await!`
        : `Your ${state.product.type} Awaits!`,
    isOpen: state.route === 'login',
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: route => dispatch({ type: 'route:to', payload: route }),
    userUpdate: payload => dispatch({ type: 'user:update', payload: payload }),
    userLogin: payload => dispatch({ type: 'user:login', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/user/login-modal.js